import { render, staticRenderFns } from "./web_tips.vue?vue&type=template&id=619ff3bc"
import script from "./web_tips.vue?vue&type=script&setup=true&lang=js"
export * from "./web_tips.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports